import Api from './apiHandler'
const BASE = 'messages'

const MessageApi = {
  getDetailMessage: (id, page) =>
    Api.get(`${BASE}/message-room/${id}?page=${page || 1}`),
  getImageMessage: (id, page) =>
    Api.get(`${BASE}/image-room/${id}?page=${page || 1}`),
  getDocumentMessage: (id, page) =>
    Api.get(`${BASE}/document-room/${id}?page=${page || 1}`),
  getMessageById: (id) => Api.get(`${BASE}/${id}`),
  sendMessage: (data) => Api.post(`${BASE}`, data),
  deleteMessage: (id) => Api.patch(`${BASE}/delete/${id}`),
}

export default MessageApi
